import { ReactNode } from "react";
import classNames from "classnames";
import parse from "html-react-parser";

import Heading, { HeadingLevel } from "@atoms/heading/Heading";

import * as styles from "@molecules/ksp/Ksp.module.scss";

interface KspProps {
  name?: string;
  title: string;
  imageSrc?: string;
  imageAlt?: string;
  headingLevel?: HeadingLevel;
  children: ReactNode;
}

const Ksp = ({
  name,
  title,
  imageSrc,
  imageAlt,
  headingLevel = 3,
  children,
}: KspProps): JSX.Element => {
  return (
    <section className={classNames(styles.ksp, "ml-ksp")}>
      {imageSrc && (
        <img
          className={classNames(styles.image, "ksp-img")}
          src={imageSrc}
          alt={imageAlt}
          loading={"lazy"}
        />
      )}
      {name && <p className="ksp-name">{name}</p>}
      <Heading level={headingLevel} adoptionClassName={classNames(styles.title, "ksp-title")}>
        {parse(title)}
      </Heading>
      {children}
    </section>
  );
};

export default Ksp;
